import {useEffect, useState} from 'react'
import {Outlet, useLocation, useMatch} from 'react-router-dom'
import {HeaderWrapper} from './components/header'
import {ScrollTop} from './components/scroll-top'
import {Content} from './components/content'
import {FooterWrapper} from './components/footer'
import {Sidebar} from './components/sidebar'

import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'
import {ToolbarWrapper} from './components/toolbar'

const MasterLayout = () => {
  const [overflowHidden, setOverflowHidden] = useState(false)
  const location = useLocation()

  useEffect(() => {
    reInitMenu()
  }, [location.key])

  var match = useMatch('/dashboard/:company/profile/*')

  useEffect(() => {
    if (match) {
      setOverflowHidden(true);
    }
  }, [match])

  return (
    <PageDataProvider>
      <div className={`d-flex flex-column flex-root app-root ${overflowHidden ? "overflow-hidden" : ""}`} id='kt_app_root'>
        <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
          <HeaderWrapper />
          <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
            <Sidebar />
            <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
              <div className='d-flex flex-column flex-column-fluid'>
                <Content>
                  <Outlet />
                </Content>
              </div>
              <FooterWrapper />
            </div>
          </div>
        </div>
      </div>
      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
